module.exports = __webpack_public_path__ + "img/PT4110.9dcf25ec.png";